export const COMMUNITY_DATA = [
  {
    title: "Become a Teacher",
    image: {
      src: "/assets/images/community/community.jpg",
      alt: "Join as a Teacher",
      title: "Join as a Teacher",
      width: 100,
      height: 100,
    },
    description:
      "Join our community of passionate educators and inspire the next generation. Share your knowledge and expertise while enjoying numerous benefits.",
    link: {
      to: "/community/teacher",
      className: "community-link teacher-link",
      text: "Apply Now",
    },
  },
  {
    title: "Join as a Member",
    image: {
      src: "/assets/images/community/community.jpg",
      alt: "Join as a Member",
      title: "Join as a Member",
      width: 100,
      height: 100,
    },
    description:
      "Access high-quality courses across various subjects and enhance your skills. Join a supportive learning community and receive exclusive benefits.",
    link: {
      to: "/community/member",
      className: "community-link member-link",
      text: "Join Today",
    },
  },
  {
    title: "Join as Student",
    image: {
      src: "/assets/images/community/community.jpg",
      alt: "Explore Courses",
      title: "Explore Courses",
      width: 100,
      height: 100,
    },
    description:
      "Discover a wide range of courses tailored to your interests and career goals. Learn from industry experts and gain recognized certifications.",
    link: {
      to: "/courses",
      className: "community-link courses-link",
      text: "Browse Courses",
    },
  },
];
